export const toastTokens = {
  toast: {
    root: {
      width: '40rem',
      borderColor: '{surface.300}',
      borderRadius: '{borderRadius.lg}',
      shadow: '0 1.25rem 2rem 0 rgba(53, 67, 88, 0.08)'
    },
    colorScheme: {
      light: {
        error: {
          color: '{danger.hoverColor}',
          background: '{surface.0}',
          accentColor: '{danger.hoverColor}'
        },
        success: {
          color: '{success.hoverColor}',
          background: '{surface.0}',
          accentColor: '{success.hoverColor}'
        },
        warn: {
          color: '{orange.300}',
          background: '{surface.0}',
          accentColor: '{orange.300}'
        },
        info: {
          color: '{info.hoverColor}',
          background: '{surface.0}',
          accentColor: '{info.hoverColor}'
        }
      }
    },
    link: {
      color: '{primary.color}'
    }
  }
};

export type ToastTokens = typeof toastTokens;
